<template>
  <div>
    <!--
    <FilterSelect v-on:child-event="parentMethod"></FilterSelect>
    <List v-bind:val="parentData"></List>
     -->
    <FilterSelect></FilterSelect>
    <List></List>
  </div>
</template>

<script>
import FilterSelect from './FilterSelect.vue'
import List from './List.vue'

export default {
  name: 'App',
  components: {
    FilterSelect,
    List,
  },
  data () {
    return {
      parentData: 'parentDataです'
    }
  },
  // methods: {
  //     parentMethod: function(fromChildVal){
  //         // alert('親がイベントを受け取った');
  //         console.log(fromChildVal);
  //     }
  // }
}
</script>

<style>
</style>
